import classNames from 'classnames';
import * as React from 'react';
import { compose, defaultProps } from 'recompose';
import { default as MUIPopover, } from '@material-ui/core/Popover';
import useStyles from './HeaderPopoverStyles';
const positionValues = {
    'bottom-right': {
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        },
        transformOrigin: {
            vertical: 'top',
            horizontal: 'right',
        },
    },
    'bottom-center': {
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center',
        },
        transformOrigin: {
            vertical: 'top',
            horizontal: 'center',
        },
    },
    'bottom-left': {
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
        },
        transformOrigin: {
            vertical: 'top',
            horizontal: 'left',
        },
    },
};
const HeaderPopover = (props) => {
    const classes = useStyles();
    const { children, closeOnClick, button, className, position, muiPopoverProps, testId = 'HeaderPopover' } = props;
    const anchorRef = React.useRef(null);
    const [open, setOpen] = React.useState(false);
    const toggleOpen = () => setOpen(!open);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { "data-testid": `${testId}-opener`, ref: anchorRef, onClick: toggleOpen, className: classNames(className, { active: open }) }, button),
        React.createElement(MUIPopover, Object.assign({ "data-testid": `${testId}-popover`, open: open, onClose: toggleOpen, anchorEl: anchorRef.current, anchorOrigin: position && positionValues[position].anchorOrigin, transformOrigin: position && positionValues[position].transformOrigin, classes: { paper: classNames({ [classes.paper]: props.popoverArrow }, position) } }, muiPopoverProps), closeOnClick ? (React.createElement("div", { "data-testid": `${testId}-closer`, onClick: () => closeOnClick && setOpen(false) }, children)) : (children))));
};
export default compose(defaultProps({
    popoverArrow: true,
    closeOnClick: false,
    position: 'bottom-center',
}))(HeaderPopover);
//# sourceMappingURL=HeaderPopover.js.map